import type { PermissionSubject } from '@practium/features/permissions';

export const ROUTE_PERMISSION_MAP: Record<string, PermissionSubject> = {
	'/dashboard': 'dashboard',
	'/propriedades': 'props',
	'/propriedades/novo': 'props',
	'/propriedades/ver': 'props',
	'/propriedades/setores/:id/flora': 'props',
	'/analises': 'samples',
	'/analises/novo': 'samples',
	'/analises/ver': 'samples',
	'/recomendacoes': 'recommendations',
	'/recomendacoes/foliares/novo': 'recommendations',
	'/recomendacoes/foliares/ver': 'recommendations',
	'/recomendacoes/manutencao/novo': 'recommendations',
	'/recomendacoes/manutencao/workspace': 'recommendations',
	'/recomendacoes/manutencao/editar': 'recommendations',
	'/recomendacoes/correcao/novo': 'recommendations',
	'/recomendacoes/correcao/workspace': 'recommendations',
	'/recomendacoes/correcao/editar': 'recommendations',
	'/usuarios': 'farmers',
	'/produtos': 'products',
	'/suporte': 'technical-support',
	'/parcelamento': 'parcelling',
};

export const FOR_BINDING_ROUTE_PERMISSION_MAP: Record<string, PermissionSubject> = {
	'/dashboard': 'dashboard',
	'/propriedades': 'farmers-props',
	'/propriedades/novo': 'farmers-props',
	'/propriedades/ver': 'farmers-props',
	'/propriedades/setores/:id/flora': 'farmers-props',
	'/analises': 'farmers-samples',
	'/analises/novo': 'farmers-samples',
	'/analises/ver': 'farmers-samples',
	'/recomendacoes': 'farmers-recommendations',
	'/recomendacoes/foliares/novo': 'farmers-recommendations',
	'/recomendacoes/foliares/ver': 'farmers-recommendations',
	'/recomendacoes/manutencao/novo': 'farmers-recommendations',
	'/recomendacoes/manutencao/workspace': 'farmers-recommendations',
	'/recomendacoes/manutencao/editar': 'farmers-recommendations',
	'/recomendacoes/correcao/novo': 'farmers-recommendations',
	'/recomendacoes/correcao/workspace': 'farmers-recommendations',
	'/recomendacoes/correcao/editar': 'farmers-recommendations',
	'/usuarios': 'farmers',
	'/parcelamento': 'parcelling',
};
